/**
 * Do not edit directly
 * Generated on Thu, 03 Mar 2022 20:09:06 GMT
 */

export const iconSvgDefaultHeight = "20px";
export const iconXSmallDefaultSize = "16px";
export const iconSmallDefaultSize = "20px";
export const iconMediumDefaultSize = "24px";
export const iconLargeDefaultSize = "28px";
export const iconXLargeDefaultSize = "32px";
export const iconXxLargeDefaultSize = "36px";